export default [
  {
    path: "/super-admin/administrators",
    name: "super_admin_home",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/administratorsView.vue"),
  },
  {
    path: "/super-admin/administrators/create",
    name: "super_admin_administrators_creation",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/administratorCreationView.vue"),
  },
  {
    path: "/super-admin/administrators/:id/edit",
    name: "super_admin_administrators_edit",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/administratorEditView.vue"),
  },
  {
    path: "/super-admin/employees",
    name: "super_admin_employees",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/employeesView.vue"),
  },
  {
    path: "/super-admin/employees/create",
    name: "super_admin_employees_creation",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/employeeCreationView.vue"),
  },
  {
    path: "/super-admin/employees/:id/edit",
    name: "super_admin_employees_edit",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/employeeEditView.vue"),
  },
  {
    path: "/super-admin/order-form-items",
    name: "super_admin_order_form_items",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/orderFormItemsView.vue"),
  },
  {
    path: "/super-admin/replacement-items",
    name: "replacement_items",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/replacementItemsView.vue"),
  },
  {
    path: "/super-admin/limits",
    name: "super_admin_limits",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/limitsView.vue"),
  },
  {
    path: "/super-admin/groups",
    name: "super_admin_groups",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/groupsView.vue"),
  },
  {
    path: "/super-admin/groups/create",
    name: "super_admin_groups_create",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/groupCreationView.vue"),
  },
  {
    path: "/super-admin/groups/:id/edit",
    name: "super_admin_groups_edit",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/groupEditView.vue"),
  },
  {
    path: "/super-admin/employee-budgets",
    name: "super_admin_budgets",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/budgetsView.vue"),
  },
  {
    path: "/super-admin/manuals",
    name: "super_admin_manuals",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/manualsView.vue"),
  },
  {
    path: "/super-admin/cityexpress",
    name: "super_admin_cityexpress",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/cityExpressView.vue"),
  },
  {
    path: "/super-admin/city-express",
    name: "super_admin_city_express_v2",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/cityExpress/Index.vue"),
  },
  {
    path: "/super-admin/ariba/sessions",
    name: "super_admin_ariba_sessions",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/superAdmin/aribaView.vue"),
  },
];
